import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { finalCta } from '../data/content';
import { siteConfig } from '../data/siteConfig';
export function FinalCta() {
  return <section id="final-cta" aria-labelledby="final-cta-heading" className="w-full bg-forest-dark px-5 py-14 text-ivory md:px-8 md:py-24" data-id="element-79" data-mp="19cumu05acon4">
      <Reveal className="mx-auto flex w-full max-w-2xl flex-col items-center text-center" data-id="element-80" data-mp="1jc3gst05i39h">
        <h2 id="final-cta-heading" className="font-serif text-[clamp(2.25rem,5vw,3.5rem)] font-medium leading-[1.08]" data-id="element-81" data-mp="1eetpf7t7bhj0">
          {finalCta.title}
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-ivory/80 md:text-lg" data-id="element-82" data-mp="1o3brdsd7vuo8">
          {finalCta.body}
        </p>

        <div aria-hidden="true" className="mt-10 h-px w-16 bg-brass" data-id="element-83" data-mp="224ee87c1d907" />
        <p className="mt-8 font-serif text-6xl font-medium leading-none text-ivory md:text-7xl" data-id="element-84" data-mp="1x51onets5ntx">
          {siteConfig.price}
        </p>
        <p className="mt-4 inline-flex items-center gap-2 text-[15px] font-semibold text-sage" data-id="element-85" data-mp="n75q22s3ex8e">
          <ShieldCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-86" data-mp="s57fd5g43ssb" />
          {siteConfig.guaranteeLabel}
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-87" data-mp="x5v8pxrtclpp">
          <CtaButton tone="onDark" fullWidth data-id="element-88" data-mp="123537ru27nke" />
        </div>
        <p className="mt-4 text-[15px] text-ivory/75" data-id="element-89" data-mp="120inh4x0m1r3">{finalCta.microcopy}</p>
      </Reveal>
    </section>;
}